import React from "react";
import verifiedLogo from "../../../assets-user/verified.svg";
import smartSearchLogo from "../../../assets-user/smartSearch.svg";
import dealsLogo from "../../../assets-user/deal.svg";
import marketLogo from "../../../assets-user/market.svg";
import trustLogo from "../../../assets-user/trust.svg";
import endToEndLogo from "../../../assets-user/ene.svg";

const FeatureHighlights = () => {
  const features = [
    { icon: verifiedLogo, title: "Verified Listings" },
    { icon: smartSearchLogo, title: "Smart Search" },
    { icon: dealsLogo, title: "Transparent Deals" },
    { icon: marketLogo, title: "Market Insights" },
    { icon: trustLogo, title: "Trusted Network" },
    { icon: endToEndLogo, title: "End-To-End Support" },
  ];

  return (
    <div className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8 lg:py-10 mt-[300px] md:mt-60 lg:mt-28">
      <div className="mx-auto">
        {/* All Devices - Auto Scrolling */}
        <div className="overflow-hidden relative">
          <div className="flex items-center gap-4 sm:gap-8 md:gap-12 lg:gap-16 animate-scroll-features">
            {[...features, ...features].map((feature, index) => (
              <div
                key={index}
                className="flex items-center gap-2 md:gap-3 flex-shrink-0"
              >
                <div className="p-2 rounded-lg flex items-center justify-center">
                  <img
                    src={feature.icon}
                    alt={feature.title}
                    className="w-8 h-8 sm:w-10 sm:h-10 text-white"
                  />
                </div>
                <span className="font-normal text-black text-center capitalize tracking-[0.01em] leading-[159%] text-lg sm:text-xl md:text-2xl lg:text-3xl">
                  {feature.title}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>
        {`
        @keyframes scrollFeatures {
          0% {
            transform: translateX(0);
          }
          100% {
              transform: translateX(-100%);
          }
        }
        .animate-scroll-features {
          display: flex;
          animation: scrollFeatures 25s linear infinite;
        }
        .animate-scroll-features:hover {
          animation-play-state: paused;
        }
      `}
      </style>
    </div>
  );
};

export default FeatureHighlights;
